import React, { useState } from "react";
import classes from "./SingleCalendar.module.css";
import { DateRangePicker, DateRange } from "react-date-range";

function SingleCalendar({ dates, setDates }) {
  const [picker, setPicker] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  return (
    <div className={classes.card}>
      <style>
        {`
            .rdrDateDisplayWrapper{
            display:none;
            }
        `}
      </style>
      <DateRange
        editableDateInputs={true}
        onChange={(item) => setPicker([item.selection])}
        moveRangeOnFirstSelection={false}
        ranges={picker}
        weekdayDisplayFormat={"eeeee"}
      />
    </div>
  );
}

export default SingleCalendar;
